import React, { useCallback } from "react";
import { useSelector } from "react-redux";
import styles from "./PrintLink.module.css";

const PrintLink = () => {
  const appliedProducts = useSelector(s => s.visualizer.appliedProducts);
  const specifier = useSelector(s => s.visualizer.specifier);

  const handleClick = useCallback(async (e) => {
    e.preventDefault();
    console.log('clicked');

    const chamviz = document.getElementById('chamViz');
    if (!chamviz || typeof chamviz.getSaveData !== 'function') {
      alert("The visualizer isn't ready yet. Try again in a moment.");
      return;
    }

    // must be safe to call now
    const saveData = chamviz.getSaveData();

    if (!appliedProducts || Object.keys(appliedProducts).length === 0) {
      alert("Please select at least 1 product.");
      return;
    }

    const printData = { appliedProducts, saveData };

    try {
      let href = '/print.html?key=using_sample_data';
      if (window.location.port !== "3000" && window.IMWC?.lizard?.getShortener) {
        const r = await window.IMWC.lizard.getShortener(
          '',
          'Mannington',
          JSON.stringify(printData),
          '{}'
        );
        const parts = String(r?.data?.shortUrl || '').split('/');
        const key = parts[parts.length - 1];
        if (key) href = `/print.html?key=${key}`;
      }
      window.open(href, '_blank', 'noopener,noreferrer');
    } catch (err) {
      console.error(err);
      alert("Could not generate print link. Please try again.");
    }
  }, [appliedProducts]);

  return (
    <a href="#" onClick={handleClick} className={styles.printLink}>
      Print
    </a>
  );
};

export default PrintLink;
